import { gql } from '@apollo/client';

export const GET_AVAILABLE_DRIVERS = gql`
  query GetAvailableDrivers {
    getAvailableDrivers {
      id
      accountId
      name
      phone
      driverLicenseNumber
      vehiclePlate
      isOnDuty
      dspId
    }
  }
`;

export interface DriverType {
  id: string;
  accountId: number;
  name: string;
  phone: string;
  driverLicenseNumber: string;
  vehiclePlate: string;
  isOnDuty: boolean;
  dspId?: number;
}

export interface GetAvailableDriversResponse {
  getAvailableDrivers: DriverType[];
}
